import { normalizeApiError } from '../api/apiError';
import { createReadAsyncThunk } from "../store/createReadAsyncThunk";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AffiliateOnboarding } from '../api/endpoints/affiliateOnboardingApi';
import { ApiRequestStatus } from "../enums/apiRequestStatus";
import AffiliateOnboardingDto from "../models/affiliateOnboarding/affiliateOnboardingDto";
import UpdateAffiliateOnboardingDto from "../models/affiliateOnboarding/updateAffiliateOnboardingDto";

interface AffiliateOnboardingDetailsSliceState {
    affiliateOnboardingDetails: AffiliateOnboardingDto | null;
    basketId: string | null;
    affiliateOnboardingCanPayStatusCodes: string[] | null;

    affiliateOnboardingDetailsStatus: ApiRequestStatus;
    updateAffiliateOnboardingDetailsStatus: ApiRequestStatus;
    basketIdStatus: ApiRequestStatus;
    affiliateOnboardingCanPayStatusCodesStatus: ApiRequestStatus;
}

const initialState: AffiliateOnboardingDetailsSliceState = {
    affiliateOnboardingDetails: null,
    basketId: null,
    affiliateOnboardingCanPayStatusCodes: null,

    affiliateOnboardingDetailsStatus: ApiRequestStatus.Idle,
    updateAffiliateOnboardingDetailsStatus: ApiRequestStatus.Idle,
    basketIdStatus: ApiRequestStatus.Idle,
    affiliateOnboardingCanPayStatusCodesStatus: ApiRequestStatus.Idle
}

export const getAffiliateOnboardingDetailsAsync = createReadAsyncThunk<AffiliateOnboardingDto | ''>(
    'affiliateOnboarding/getAffiliateOnboardingDetailsAsync',
    async (_, thunkAPI) => {
        try {
            return await AffiliateOnboarding.getAffiliateOnboardingDetailsAsync();
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const getAffiliateOnboardingCanPayStatusCodesAsync = createReadAsyncThunk<string[]>(
    'affiliateOnboarding/getAffiliateOnboardingCanPayStatusCodesAsync',
    async (_, thunkAPI) => {
        try {
            return await AffiliateOnboarding.getAffiliateOnboardingCanPayStatusCodesAsync();
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const updateAffiliateOnboardingDetailsAsync = createAsyncThunk<void, UpdateAffiliateOnboardingDto>(
    'affiliateOnboarding/updateAffiliateOnboardingDetailsAsync',
    async (affiliateOnboardingDetails, thunkAPI) => {
        try {
            return await AffiliateOnboarding.updateAffiliateOnboardingDetailsAsync(affiliateOnboardingDetails);
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const basketAsync = createAsyncThunk<string>(
    'affiliateOnboarding/basketAsync',
    async (_, thunkAPI) => {
        try {
            return await AffiliateOnboarding.basketAsync();
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const affiliateOnboardingSlice = createSlice({
    name: 'affiliateOnboardingSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder => {
        builder.addCase(getAffiliateOnboardingDetailsAsync.pending, (state) => {
            state.affiliateOnboardingDetailsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getAffiliateOnboardingDetailsAsync.fulfilled, (state, action) => {
            state.affiliateOnboardingDetailsStatus = ApiRequestStatus.Fulfilled;
            state.affiliateOnboardingDetails = action.payload === "" ? null : action.payload;
        });
        builder.addCase(getAffiliateOnboardingDetailsAsync.rejected, (state) => {
            state.affiliateOnboardingDetailsStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(getAffiliateOnboardingCanPayStatusCodesAsync.pending, (state) => {
            state.affiliateOnboardingCanPayStatusCodesStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getAffiliateOnboardingCanPayStatusCodesAsync.fulfilled, (state, action) => {
            state.affiliateOnboardingCanPayStatusCodesStatus = ApiRequestStatus.Fulfilled;
            state.affiliateOnboardingCanPayStatusCodes = action.payload;
        });
        builder.addCase(getAffiliateOnboardingCanPayStatusCodesAsync.rejected, (state) => {
            state.affiliateOnboardingCanPayStatusCodesStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(updateAffiliateOnboardingDetailsAsync.pending, (state) => {
            state.updateAffiliateOnboardingDetailsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(updateAffiliateOnboardingDetailsAsync.fulfilled, (state, action) => {
            state.updateAffiliateOnboardingDetailsStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(updateAffiliateOnboardingDetailsAsync.rejected, (state) => {
            state.updateAffiliateOnboardingDetailsStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(basketAsync.pending, (state) => {
            state.basketIdStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(basketAsync.fulfilled, (state, action) => {
            state.basketId = action.payload;
            state.basketIdStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(basketAsync.rejected, (state) => {
            state.basketIdStatus = ApiRequestStatus.Rejected;
        });
    })
})
